const tourList = (state = {}, action) => {
    switch (action.type) {
        case 'SAVE_TOUR_LIST':
            return action.tourList
        default:
            return state
    }
}

export default tourList
